import { render, staticRenderFns } from "./UserRoles.vue?vue&type=template&id=4c7f05f7&scoped=true&"
import script from "./UserRoles.vue?vue&type=script&lang=ts&"
export * from "./UserRoles.vue?vue&type=script&lang=ts&"
import style0 from "./UserRoles.vue?vue&type=style&index=0&id=4c7f05f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7f05f7",
  null
  
)

export default component.exports